/* VA kit: comportamiento de las secciones va-* */
(function () {
  if (window.__vaKit) return; window.__vaKit = true;
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function drawer() { return document.querySelector('cart-drawer'); }
  function openCart(e) { var d = drawer(); if (d && typeof d.open === 'function') { if (e) e.preventDefault(); d.open(); } }
  function init(root) {
    root = root || document;
    $$('.va-gal', root).forEach(function (g) {
      if (g.__va) return; g.__va = 1;
      var main = g.querySelector('.va-main img');
      $$('[data-full]', g).forEach(function (t) {
        function go() {
          $$('[data-full]', g).forEach(function (x) { x.classList.remove('va-on'); });
          t.classList.add('va-on'); if (main) { main.removeAttribute('srcset'); main.src = t.getAttribute('data-full'); }
        }
        t.addEventListener('click', go);
        t.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); go(); } });
      });
    });
    $$('.va-qb', root).forEach(function (q) {
      if (q.__va) return; q.__va = 1;
      var sec = q.closest('[data-va-buy]');
      function pick(b) {
        $$('.va-bar', q).forEach(function (x) { x.classList.toggle('va-on', x === b); x.setAttribute('aria-checked', x === b ? 'true' : 'false'); });
        if (!sec || sec.classList.contains('va-has-app')) return;
        var f = sec.querySelector('form[action*="/cart/add"]');
        if (!f) return;
        var id = f.querySelector('[name="id"]'), qty = f.querySelector('[name="quantity"]');
        if (id && b.getAttribute('data-variant')) id.value = b.getAttribute('data-variant');
        if (qty && b.getAttribute('data-qty')) qty.value = b.getAttribute('data-qty');
      }
      $$('.va-bar', q).forEach(function (b) {
        b.addEventListener('click', function () { pick(b); });
        b.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); pick(b); } });
      });
      var on = q.querySelector('.va-bar.va-on') || q.querySelector('.va-bar'); if (on) pick(on);
    });
    $$('.va-ss2', root).forEach(function (s) {
      if (s.__va) return; s.__va = 1; s.classList.add('va-js');
      if (!('IntersectionObserver' in window)) { s.classList.add('va-on'); return; }
      var io = new IntersectionObserver(function (en) { en.forEach(function (x) { if (x.isIntersecting) { s.classList.add('va-on'); io.disconnect(); } }); }, { threshold: .3 });
      io.observe(s);
    });
    $$('.va-crs', root).forEach(function (c) {
      if (c.__va) return; c.__va = 1;
      var trk = c.querySelector('.va-trk'), wrap = c.parentNode, dots = $$('.va-dots i', wrap);
      if (!trk) return;
      function idx() { return Math.round(trk.scrollLeft / Math.max(1, trk.clientWidth)); }
      function go(i) { var n = trk.children.length; i = (i + n) % n; trk.scrollTo({ left: i * trk.clientWidth, behavior: 'smooth' }); }
      var p = c.querySelector('.va-arw.va-p'), nx = c.querySelector('.va-arw.va-n');
      if (p) p.addEventListener('click', function () { go(idx() - 1); });
      if (nx) nx.addEventListener('click', function () { go(idx() + 1); });
      dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i); }); });
      trk.addEventListener('scroll', function () { var i = idx(); dots.forEach(function (d, j) { d.classList.toggle('va-on', i === j); }); }, { passive: true });
    });
    $$('.va-hdr', root).forEach(function (h) {
      if (h.__va) return; h.__va = 1;
      var dlg = h.querySelector('dialog'), tg = h.querySelector('.va-okn-menu-toggle');
      if (!dlg || !tg) return;
      function close() { if (dlg.open) dlg.close(); }
      tg.addEventListener('click', function () { if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', ''); document.documentElement.classList.add('va-okd-lock'); tg.setAttribute('aria-expanded', 'true'); });
      dlg.addEventListener('close', function () { document.documentElement.classList.remove('va-okd-lock'); tg.setAttribute('aria-expanded', 'false'); });
      $$('.va-okn-menu-close, a', dlg).forEach(function (a) { a.addEventListener('click', close); });
      dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); });
    });
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-va-atc]');
    if (a) {
      e.preventDefault(); e.stopPropagation();
      if (a.classList.contains('va-loading') || a.getAttribute('aria-disabled') === 'true') return;
      var sec = a.closest('[data-va-buy]'), f = sec && sec.querySelector('form[action*="/cart/add"]');
      if (!f) return;
      var btn = f.querySelector('[type=submit]');
      a.classList.add('va-loading'); setTimeout(function () { a.classList.remove('va-loading'); }, 2500);
      if (f.requestSubmit) f.requestSubmit(btn); else btn.click();
      return;
    }
    var c = e.target.closest('[data-va-cart]');
    if (c) { openCart(e); return; }
    var l = e.target.closest('.va-page a[href^="#"]');
    if (l) {
      var id = l.getAttribute('href').slice(1); if (!id) return;
      var t = document.getElementById(id);
      if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    }
  }, true);
  /* Si una app (Kaching) inserta su selector de ofertas, se ocultan los paquetes propios */
  function appCheck() {
    $$('[data-va-buy]').forEach(function (sec) {
      var has = !!sec.querySelector('kaching-bundle, kaching-bundles-block, .kaching-bundles');
      if (has && !sec.classList.contains('va-has-app')) {
        sec.classList.add('va-has-app');
        var q = sec.querySelector('form[action*="/cart/add"] [name="quantity"]'); if (q) q.value = 1;
      } else if (!has) sec.classList.remove('va-has-app');
    });
  }
  var _ap; new MutationObserver(function () { if (_ap) return; _ap = setTimeout(function () { _ap = 0; appCheck(); }, 120); }).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('cart-drawer:update', function () { $$('.va-loading').forEach(function (x) { x.classList.remove('va-loading'); }); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); appCheck(); }); else { init(); appCheck(); }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); appCheck(); });
})();
